<style>
	.name1{
		font-size: 0.32rem;
		    max-width: 2.6rem;
		    width: 1.8rem;
	}
	.line6 {
	    text-overflow: ellipsis;
	    white-space: nowrap;
	}
	.shuoming{
		padding: 0.6rem 0.88rem 0.2rem 0.55rem;
	}
	.shuoming .cashshuoming {
	      font-size: .35rem;
	          color: #555353;
	          letter-spacing: 2px;
	          font-weight: bolder;
	          padding: .2rem;
	}
	.tupian{
		margin-top: 0.5rem;
	}
	.imgasd{
		width: inherit;
	}
	.header56 {
	    padding: 0 0.3rem;
	    height: 3rem;
	    position: relative;
  }
  
  .button{
    float:left;
    width: 2.2rem;
    background: rgb(255, 255, 255);
    color: rgb(216, 59, 44);
    margin-top: 0.3rem;
    margin-bottom: -0.3rem;
    text-align: center;
    padding: 0.15rem 0.5rem;
    border-radius: 15px;
  }
	
</style>
<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper" style="">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name1 line6">{{ userInfo.nickname }}</div>			
          </div>
          <p class="id" v-if = "userInfo.is_hy === 0">
            普通会员
          </p>
          <p class="id" v-else-if="myisvip.sday > 0">
            悦享会员  |  剩余：{{ myisvip.sday }}天
          </p>
          <p class="id" v-else>
            悦享会员  |  已过期：{{ myisvip.days }}天
          </p>
        </div>
		<span class='guoqi'></span>
		<div style='width: 7rem;'>
			<router-link :to="'/user/user_myvip_xu'">
			<div class="member acea-row row-middle button">{{ userInfo.btname }}</div>
			</router-link>

			<div style="float: right;margin-top: 0.5rem; margin-bottom: -0.5rem;color: #fff;">
        <p v-if = "userInfo.is_hy === 1">有效期至：{{ myisvip.hy_to_time }}</p>
        </div>
		</div>
      </div>
    </div>
	
    <img src="@assets/images/myvip.jpg" class="imgasd"/>
    </div>

</template>
<script>
import { getUser} from "@api/user";
import { getMyisvip} from "@api/yongjin";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";

const NAME = "UserMyvip";

export default {
  name: NAME,
  components: {
    SwitchWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
	    myisvip: {},
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
	  this.Myvip();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        if (that.userInfo.is_hy === 0) 
        that.userInfo['btname']='立即开通';
        else
        that.userInfo['btname']='立即续费';
      });
    },
	Myvip: function() {
	  let that = this;
	  getMyisvip().then(res => {
      that.myisvip = res.data.user;
	  });
	},
  }
};
</script>
